import React from 'react'
import Layout from '../../common/Layout'
import AdminstratorAddContainer from '../../features/AdministrationPortal/Administrators/AdministratorAddContainer/AdministratorAddContainer'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  path: '/administration/administrators/add',
  async action () {
    return {
      title: 'Administrator Add',
      component: <Layout containerWell>
        <AdminstratorAddContainer />
      </Layout>
    }
  }
}
